document.addEventListener('click', async (event) => {
    // Only proceed if the clicked element is the load more button
    if (event.target.id !== 'load-more') {
      return;
    }
  
    event.preventDefault();
  
    const loadMoreBtn = event.target;
    const loadMoreContainer = document.getElementById('load-more-container');
    const loadMoreSpinner = document.getElementById('load-more-spinner');
    const productGrid = document.getElementById('product-grid');
  
    // Guard clauses to ensure necessary elements exist
    if (!productGrid || !loadMoreContainer) {
      console.error('Required elements (product-grid or load-more-container) not found.');
      return;
    }
  
    const nextUrl = loadMoreBtn.dataset.nextUrl;
    if (!nextUrl) {
      return;
    }
  
    // --- Set loading state ---
    loadMoreBtn.style.display = 'none';
    if (loadMoreSpinner) {
      loadMoreSpinner.style.display = 'flex';
    }
  
    try {
      // Fetch the next page content
      const response = await fetch(nextUrl);
      const html = await response.text();
      const parser = new DOMParser();
      const newDocument = parser.parseFromString(html, 'text/html');
  
      // Extract new products and the next page's load more button
      const newProducts = newDocument.querySelectorAll('#product-grid > li.load-item ');
      const nextLoadMoreBtn = newDocument.getElementById('load-more');
  
      // Append new products to the grid
      newProducts.forEach(product => {
        productGrid.appendChild(product.cloneNode(true));
      });
  
      // --- Update button for the next page or hide it ---
      const newNextUrl = nextLoadMoreBtn ? nextLoadMoreBtn.dataset.nextUrl : null;
      if (newNextUrl) {
        loadMoreBtn.dataset.nextUrl = newNextUrl;
        loadMoreBtn.style.display = 'block'; // Show button for the next page
      } else {
        loadMoreContainer.style.display = 'none'; // No more pages, hide container
      }
  
    } catch (error) {
      console.error('Error loading more products:', error);
      loadMoreBtn.style.display = 'block'; // Show button again on error to allow retry
    } finally {
      // --- Always hide spinner after operation ---
      if (loadMoreSpinner) {
        loadMoreSpinner.style.display = 'none';
      }
    }
  });